import toCurrency from '@/shared/directive/toCurrency';
import ItemsDetailed from './billing-detailed-entitys.ts/items-detailed.entity';
import CalculationsDetailed from './billing-detailed-entitys.ts/calculations-detailed.entity';
import BillingListBase from './billing-list-base.entity';

export default class BillingList extends BillingListBase {
  invoiceWithHoldingTaxValue: string;

  payeeName: string;

  items: ItemsDetailed[] = [];

  observations: string;

  constructor(obj: any = {}) {
    super(obj);
    this.invoiceWithHoldingTaxValue = obj.invoiceWithHoldingTaxValue;
    this.payeeName = obj.payeeName;
    if (obj.items) this.items = ItemsDetailed.ofList(obj.items);
    this.observations = obj.observations;
  }

  public static of(obj: any = {}): BillingList {
    return new BillingList(obj);
  }

  public static ofList(obj: any[]): BillingList[] {
    return obj.map(this.of);
  }

  get beneficiariesJoined(): string {
    return this.items.filter((el: ItemsDetailed) => el.beneficiary)
      .map((el: any) => `${el.beneficiary}`).join(', ')
  }

  get itemsGrouped(): string {
    const length = this.items.length;
    return length > 1 ? `${length} Itens` : this.items[0].description;
  }

  get itemsJoined(): string {
    return this.items.map((el: ItemsDetailed) => `${el.description}`).join(', ')
  }

  get discountObservationJoined(): String {
    return this.items.map(
      (el: ItemsDetailed) => `${el?.discountHistory?.discountObservation || ''}`,
    ).join(', ');
  }

  get discountJustificationJoined(): String {
    return this.items.map(
      (el: ItemsDetailed) => `${el?.discountHistory?.discountJustification || ''}`,
    ).join(', ');
  }

  get discountResponsibleJoined(): String {
    return this.items.map(
      (el: ItemsDetailed) => `${el?.discountHistory?.discountResponsible || ''}`,
    ).join(', ');
  }

  get discountDiscountTypeJoined(): String {
    return this.items.map(
      (el: ItemsDetailed) => `${el.discountHistory?.discountType || ''}`,
    ).join(', ');
  }

  get discountDiscountValueJoined(): string {
    let value = 0;
    const listItens = this.items.filter((el: ItemsDetailed) => el.calculations.length > 0);
    if (listItens) {
      listItens.forEach((el: ItemsDetailed) => {
        el.calculations.forEach((it: CalculationsDetailed) => {
          value += (it.discountedValue || 0);
        });
      });
    }
    return toCurrency(value, this.currency.name, this.currency.symbol);
  }
}
